import {
    Paper,
    Table as TableMUI,
    TableBody as TableBodyMUI,
    TableCell as TableCellMUI,
    TableCellProps,
    TableContainer as TableContainerMUI,
    TableHead as TableHeadMUI,
    TableRow as TableRowMUI
} from '@material-ui/core'
import React, { FC, ReactElement } from 'react'
import Heading, { HeadingLevel } from '../Heading'

type TableCellData = Nullable<string | number | ReactElement>

export type TableColumn = {
    content: TableCellData
    props?: TableCellProps
}

export type TableRow = {
    rowClassName?: string
    columns: TableColumn[]
}

export type TableRows = TableRow[]

export type TableData = {
    headings?: TableRow
    rows: TableRows
}

type Props = {
    title?: string
    tableData: TableData
}

export const Table: FC<Props> = ({ title, tableData }: Props): ReactElement => (
    <TableContainerMUI className='table-container' component={Paper}>
        {title && (
            <div className='table-title-bar'>
                <Heading level={HeadingLevel.TWO}>{title}</Heading>
            </div>
        )}
        <TableMUI>
            {tableData?.headings && (
                <TableHeadMUI>
                    <TableRowMUI className='table-head'>
                        {tableData?.headings?.columns?.map(
                            ({ props, content }: TableColumn, index: number): ReactElement => (
                                <TableCellMUI {...props} key={`table-head-${index}`}>
                                    {content}
                                </TableCellMUI>
                            )
                        )}
                    </TableRowMUI>
                </TableHeadMUI>
            )}
            <TableBodyMUI>
                {tableData.rows.map(
                    (row: TableRow, index: number): ReactElement => (
                        <TableRowMUI className={`table-row ${row.rowClassName}`} key={`table-row-${index}`}>
                            {row.columns.map(
                                ({ props, content }: TableColumn, i: number): ReactElement => (
                                    <TableCellMUI {...props} key={`table-cell-${i}`}>
                                        {content}
                                    </TableCellMUI>
                                )
                            )}
                        </TableRowMUI>
                    )
                )}
            </TableBodyMUI>
        </TableMUI>
    </TableContainerMUI>
)
